import { ChangeEvent, FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ModalDialog from '../../../common/components/ModalDialog';
import ButtonGroup from '../../../common/components/ButtonGroup';
import IssueComment from '../../../elements/IssueComment/IssueComment';

const AddCommentModal: FC<React.PropsWithChildren<AddCommentModalProps>> = ({
  open,
  onCloseAddingComment,
  handleAddingComment,
  isLoading,
  children,
  comment,
  issueName,
  setIssueCommentTemp,
}) => {
  const theme = useTheme();

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label={!comment ? 'Add Comment' : 'Edit Comment'}
      open={open}
      onClose={onCloseAddingComment}
      modalHeader={!comment ? 'Add Comment' : 'Edit Comment'}>
      {children}
      <Box flexGrow={1}>
        <Typography
          color={theme.palette.text.primary}
          variant='body1'
          component='div'>
          <p>Please add a comment for:</p>
          <p style={{ fontWeight: 'bold', marginBlockStart: '5px' }}>
            {issueName}
          </p>
        </Typography>
      </Box>
      <IssueComment
        commentTemp={comment}
        setIssueCommentTemp={setIssueCommentTemp}
      />
      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={onCloseAddingComment}
          onClick={handleAddingComment}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Cancel'
          buttonActionLabel={comment ? 'Edit' : 'Add'}
          buttonActionTooltip={comment ? 'Edit' : 'Add'}
          isActionDisabled={false}
          isLoading={isLoading}
        />
      </Box>
    </ModalDialog>
  );
};

export interface AddCommentModalProps {
  open: boolean;
  onCloseAddingComment: () => void;
  handleAddingComment: () => void;
  isLoading: boolean;
  comment?: string;
  issueName?: string;
  setIssueCommentTemp: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export default AddCommentModal;
